"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = _interopRequireDefault(require("../utils/logger"));

var EventGate = function EventGate(client) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, EventGate);
  (0, _defineProperty2["default"])(this, "_shouldAllowSends", void 0);
  (0, _defineProperty2["default"])(this, "_preloadEvents", void 0);
  (0, _defineProperty2["default"])(this, "_client", void 0);
  (0, _defineProperty2["default"])(this, "pushPreloadEvent", function (eventSpecs) {
    return new Promise(function (resolve) {
      _this._preloadEvents.push({
        specs: eventSpecs,
        resolvePromise: resolve
      });
    });
  });
  (0, _defineProperty2["default"])(this, "queuePreloadEvents", function () {
    _this._preloadEvents.forEach(function (event) {
      var structuredData = _this._client.structureData(event.specs);

      _this._client.batcher.queueEvent(structuredData, event.options || {}).then(event.resolvePromise)["catch"](function (e) {
        return _logger["default"].error(e);
      });
    });

    _this._preloadEvents = [];
  });
  (0, _defineProperty2["default"])(this, "allowSends", function () {
    _this._shouldAllowSends = true;
  });
  (0, _defineProperty2["default"])(this, "blockSends", function () {
    _this._shouldAllowSends = false;
  });
  (0, _defineProperty2["default"])(this, "shouldAllowSends", function () {
    return _this._shouldAllowSends;
  });
  this._client = client;
  this._shouldAllowSends = false;
  this._preloadEvents = [];
};

var _default = EventGate;
exports["default"] = _default;